import React, { useCallback, useRef } from 'react';

interface ResizeHandleProps {
  onResize: (delta: number) => void;
}

const ResizeHandle: React.FC<ResizeHandleProps> = ({ onResize }) => {
  const startX = useRef<number>(0);
  const isResizing = useRef<boolean>(false);

  const handleMouseDown = useCallback((e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    startX.current = e.clientX;
    isResizing.current = true;
    
    document.body.style.cursor = 'col-resize';
    document.body.style.userSelect = 'none';

    const handleMouseMove = (moveEvent: MouseEvent) => {
      if (!isResizing.current) return;
      
      const delta = moveEvent.clientX - startX.current;
      onResize(delta);
      startX.current = moveEvent.clientX;
    };

    const handleMouseUp = () => {
      isResizing.current = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
      
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  }, [onResize]);

  return (
    <div
      onMouseDown={handleMouseDown}
      style={{
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        cursor: 'col-resize',
        backgroundColor: 'transparent',
        zIndex: 1,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.3)';
      }}
      onMouseLeave={(e) => {
        if (!isResizing.current) {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
    />
  );
};

export default ResizeHandle;